module.exports = __webpack_public_path__ + "static/media/history_16.0b221fc9.jpg";